"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React, { createRef } from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { Treebeard } from "react-treebeard";
import { action, computed, observable } from "mobx";
import { customDecorators, customTheme } from "./TreebeardDecorators";
export var FolderTree = /*#__PURE__*/function (_React$Component) {
  _inherits(FolderTree, _React$Component);
  var _super = _createSuper(FolderTree);
  function FolderTree() {
    var _this;
    _classCallCheck(this, FolderTree);
    _this = _super.apply(this, arguments);
    _this.treeParentRef = createRef();
    _this.folderBeingDragged = null;
    return _this;
  }
  _createClass(FolderTree, [{
    key: "render",
    value: function render() {
      var className = this.props.className;
      return /* @__PURE__ */React.createElement("div", {
        className: classNames("treebeard", _defineProperty({}, "".concat(className), !!className)),
        ref: this.treeParentRef
      }, /* @__PURE__ */React.createElement(Treebeard, {
        data: this.parsedFolderData,
        onToggle: this.onToggle,
        onSelect: this.onSelect,
        decorators: customDecorators,
        style: customTheme
      }));
    }
  }, {
    key: "onToggle",
    value: function onToggle(node) {
      this.props.viewStore.onToggle(node.id);
    }
  }, {
    key: "onSelect",
    value: function onSelect(node) {
      var _this$props = this.props,
        onSelect = _this$props.onSelect,
        viewStore = _this$props.viewStore;
      var id = node.id;
      if (!viewStore.isFolderToggledOpen(id) || viewStore.isFolderSelected(id)) {
        this.onToggle(node);
      }
      onSelect(id);
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(event, folderId) {
      var onDragStart = this.props.onDragStart;
      if (!!onDragStart) {
        onDragStart(event, folderId);
        this.folderBeingDragged = folderId;
      }
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd() {
      this.folderBeingDragged = null;
      if (this.props.onDragEnd) {
        this.props.onDragEnd();
      }
    }
  }, {
    key: "parsedFolderData",
    get: function get() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        onDragStart = _this$props2.onDragStart,
        onDropOnFolder = _this$props2.onDropOnFolder,
        onNameChange = _this$props2.onNameChange,
        onRenameConfirm = _this$props2.onRenameConfirm,
        onRenameCancel = _this$props2.onRenameCancel,
        viewStore = _this$props2.viewStore,
        maxNameLength = _this$props2.maxNameLength,
        onDeleteFolder = _this$props2.onDeleteFolder,
        onCreateFolder = _this$props2.onCreateFolder,
        disableOptions = _this$props2.disableOptions;
      var folders = viewStore.folders;
      var idMap = /* @__PURE__ */new Map();
      var allTreebeardFolders = [];
      var roots = [];
      var sharedProps = {
        className: className,
        onDragStart: this.handleDragStart,
        onDragEnd: this.handleDragEnd,
        onDropOnFolder: onDropOnFolder,
        onNameChange: onNameChange,
        onRenameConfirm: onRenameConfirm,
        onRenameCancel: onRenameCancel,
        maxNameLength: maxNameLength,
        onDeleteFolder: onDeleteFolder,
        onCreateFolder: onCreateFolder,
        disableOptions: disableOptions,
        treeParentRef: this.treeParentRef
      };
      for (var i = 0; i < folders.length; ++i) {
        var folder = folders[i];
        idMap.set(folder.id, i);
        var toggled = viewStore.isFolderToggledOpen(folder.id);
        var selected = viewStore.isFolderSelected(folder.id);
        allTreebeardFolders.push(__spreadValues({
          id: folder.id,
          name: folder.name,
          toggled: toggled,
          selected: selected,
          renaming: folder.renaming || false,
          children: [],
          draggable: !!onDragStart,
          animationState: folder.animationState,
          isLoading: folder.isLoading,
          disableSelect: folder.disableSelect || false,
          isBeingDragged: false
        }, sharedProps));
      }
      for (var _i = 0; _i < folders.length; ++_i) {
        var _folder = folders[_i];
        if (!!_folder.parent && idMap.has(_folder.parent)) {
          var currentTreebeardFolder = allTreebeardFolders[_i];
          var parentIndex = idMap.get(_folder.parent);
          var parentFolder = allTreebeardFolders[parentIndex];
          parentFolder.children.push(currentTreebeardFolder);
          currentTreebeardFolder.parentId = parentFolder.id;
          if (currentTreebeardFolder.selected) {
            toggleAncestors(allTreebeardFolders, currentTreebeardFolder, idMap);
          }
        } else {
          roots.push(allTreebeardFolders[_i]);
        }
      }
      if (this.folderBeingDragged && idMap.has(this.folderBeingDragged)) {
        var treebeardFolderBeingDragged = allTreebeardFolders[idMap.get(this.folderBeingDragged)];
        addBeingDraggedFlag(treebeardFolderBeingDragged);
      }
      return roots;
    }
  }]);
  return FolderTree;
}(React.Component);
FolderTree.defaultProps = {
  maxNameLength: 256
};
__decorateClass([observable], FolderTree.prototype, "folderBeingDragged", 2);
__decorateClass([action.bound], FolderTree.prototype, "onToggle", 1);
__decorateClass([action.bound], FolderTree.prototype, "onSelect", 1);
__decorateClass([action.bound], FolderTree.prototype, "handleDragStart", 1);
__decorateClass([action.bound], FolderTree.prototype, "handleDragEnd", 1);
__decorateClass([computed], FolderTree.prototype, "parsedFolderData", 1);
FolderTree = __decorateClass([observer], FolderTree);
function toggleAncestors(allFolders, current, map) {
  if (current.parentId) {
    var parentIndex = map.get(current.parentId);
    var parent = allFolders[parentIndex];
    parent.toggled = true;
    toggleAncestors(allFolders, parent, map);
  }
}
function addBeingDraggedFlag(treebeardFolderBeingDragged) {
  var traversalQueue = [treebeardFolderBeingDragged];
  while (traversalQueue.length > 0) {
    var nextTreebeardFolder = traversalQueue.pop();
    nextTreebeardFolder.isBeingDragged = true;
    var _iterator2 = _createForOfIteratorHelper(nextTreebeardFolder.children),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var child = _step2.value;
        traversalQueue.push(child);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
}